import { render, staticRenderFns } from "./BoxedTextContainerStyle.vue?vue&type=template&id=020e3700&"
import script from "./BoxedTextContainerStyle.vue?vue&type=script&lang=js&"
export * from "./BoxedTextContainerStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports